// Fonctions utilitaires pour générer les identifiants des récolteurs

/**
 * Génère un nom d'utilisateur unique pour un récolteur
 * Format: rcl001, rcl002, etc.
 */
export const generateRecolteurUsername = (existingUsernames = []) => {
  let username;
  let isUnique = false;
  let attempts = 0;
  const maxAttempts = 1000;

  while (!isUnique && attempts < maxAttempts) {
    // Générer un username basé sur un numéro aléatoire
    const randomNum = Math.floor(Math.random() * 9000) + 1000; // 4 chiffres
    username = `rcl${randomNum}`;

    // Vérifier l'unicité
    if (!existingUsernames.includes(username)) {
      isUnique = true;
    }
    attempts++;
  }

  if (!isUnique) {
    // Fallback: utiliser timestamp
    username = `rcl${Date.now().toString().slice(-6)}`;
  }

  return username;
};

/**
 * Génère un mot de passe aléatoire
 * Format: 3 chiffres + 3 lettres
 */
export const generateRecolteurPassword = () => {
  const chiffres = '0123456789';
  const lettres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  
  let password = '';
  
  // 3 chiffres aléatoires
  for (let i = 0; i < 3; i++) {
    password += chiffres.charAt(Math.floor(Math.random() * chiffres.length));
  }
  
  // 3 lettres aléatoires
  for (let i = 0; i < 3; i++) {
    password += lettres.charAt(Math.floor(Math.random() * lettres.length));
  }
  
  return password;
};

/**
 * Génère un matricule unique pour un récolteur
 * Format: RCL-001, RCL-002, etc.
 */
export const generateRecolteurMatricule = (existingMatricules = []) => {
  let numero = 1;
  let matricule;
  let isUnique = false;
  const maxAttempts = 1000;
  let attempts = 0;

  // Trouver le dernier numéro utilisé
  if (existingMatricules.length > 0) {
    const numeros = existingMatricules
      .map(m => {
        const match = m?.match(/RCL-(\d+)/);
        return match ? parseInt(match[1]) : 0;
      })
      .filter(n => n > 0);
    
    if (numeros.length > 0) {
      numero = Math.max(...numeros) + 1;
    }
  }

  while (!isUnique && attempts < maxAttempts) {
    // Formater avec des zéros devant (001, 002, etc.)
    const numeroFormate = numero.toString().padStart(3, '0');
    matricule = `RCL-${numeroFormate}`;

    // Vérifier l'unicité
    if (!existingMatricules.includes(matricule)) {
      isUnique = true;
    } else {
      numero++;
    }
    attempts++;
  }

  if (!isUnique) {
    // Fallback: utiliser timestamp
    const timestamp = Date.now().toString().slice(-6);
    matricule = `RCL-${timestamp}`;
  }

  return matricule;
};

